import { Component } from '@angular/core';

import { PermissionsEditorService } from './permissions-editor.service';

/**
 * This component displays the Permission editor popup
 */
@Component({
    selector: 'cw-permissions-editor',
    templateUrl: './permissions-editor.component.html',
    styleUrls: ['./permissions-editor.component.scss'],
    standalone: false,
})
export class PermissionsEditorComponent {
    constructor(public permissionsEditorService: PermissionsEditorService) {}
}
